var _path, _polygon, _polygon2, _rect, _path2, _path3, _g, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _g2, _path12, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 527,
    viewBox: "0 0 524.67004 627.58313",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.80817,216.8434h-51.76199v-17.04364c0-28.56819,23.19376-51.76195,51.76196-51.76195h.00006v68.80557h0l-.00003,.00002Z",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "409.33502 185.02664 418.23483 225.05637 366.08304 216.39671 387.33502 178.53845 409.33502 185.02664",
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.33502 185.02664 418.23483 225.05637 366.08304 216.39671 387.33502 178.53845 409.33502 185.02664",
    isolation: "isolate",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 359.33502,
    y: 270.53845,
    width: 50,
    height: 74,
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441.83502,405.03845l-11,59s7,41-14,83l-14,43-21-3s13-32,13-46,3-68,3-68l-1.5-61.6181,45.5-6.3819Z",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M378.83502,586.03845s24-9,26,4l-1,6s9,27-4,29-25,5-26-1-.98425-13.48969,1.50787-18.74481c2.49213-5.25519,3.49213-19.25519,3.49213-19.25519Z",
    fill: "#2f2e41"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.13446,395.88629l-5.84241,59.73163s-18.12634,37.43576-9.63538,83.61914l1.48898,45.19714,21.00586,2.95868s-3.58765-34.35303,.30588-47.80072,16.02979-66.15167,16.02979-66.15167l18.57739-58.77008-41.93011-18.78409v-.00003Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31125,587.2666s-20.5502-15.31958-26.08673-3.38867l-.7081,6.04138s-16.1539,23.43182-4.22299,28.96838c11.93091,5.5365,22.6232,11.75549,25.25238,6.27032,2.62921-5.48517,4.69702-12.68378,3.76474-18.42468-.93231-5.74097,2.0007-19.46674,2.0007-19.46674Z",
    fill: "#2f2e41"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M429.83502,310.53845c23.51917,21.94757,25.26404,56.67346,11.5,98,0,0-44,30-76-8l-16-77,80.5-13Z",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390.33502,203.53845l25,4-2,63,28,56-36,18s-28-53-33-86-2-57-2-57l20,2Z",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M371.33502,205.53845l-25,4,2,63-6,58,14,16s28-53,33-86,2-57,2-57l-20,2Z",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M401.33502,207.03845l5.5-1.5s19.5-2.5,22.5,5.5,2,55,2,55c0,0,5.16,57.68503-14.92001,58.34253-20.07999,.65747-16.07999-47.34253-16.07999-47.34253l1-70Z",
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400.60837,
    cy: 170.13133,
    r: 25.881,
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368.33502,209.03845l-5.5-1.5s-19.5-2.5-22.5,5.5-2,55-2,55c0,0-5.16,57.68503,14.92001,58.34253s16.07999-47.34253,16.07999-47.34253l-1-70Z",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M385.65787,205.75047c-5.55215-1.40863-11.8468,4.52132-14.06128,13.24854-.93243,3.47409-1.01932,7.12088-.25339,10.63535l-2.38571,9.92043-.17551-.00925-18.81824,44.34888c-4.37546,10.31165-3.91315,22.14969,1.66766,31.862,3.31989,5.77765,7.67792,9.66177,12.79498,5.69681,8.49084-6.57913,14.03687-44.24918,16.56906-65.88826l5.85495-21.9959c2.35019-2.72464,4.01346-5.97256,4.85068-9.47191,2.2149-8.72385-.49106-16.938-6.04318-18.34671l-.00003,.00003Z",
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M351.05969,191.06934c1.31647-4.00284,3.91522-7.50723,5.07797-11.55742,1.54385-5.37762,4.83075,6.55243,5.15143,.96678,.6095-10.61668,16.81287-37.92627,26.06317-43.17206,9.25027-5.24583,14.56314-3.66417,23.98727,1.2625,0,0,4.57462,.29092,10.26981,3.10268,5.69519,2.81174,10.82162,7.31487,13.03674,13.26749,1.7558,4.71829,1.56146,9.89986,2.14813,14.89992,1.63437,13.92995,9.44293,27.17801,7.76691,41.10298-.52286,4.3445-2.17419,8.83707-5.72638,11.39244-3.55222,2.55534-9.29105,2.27736-11.62924-1.42142-.79788-1.26218-1.13531-2.75964-1.81906-4.08713-.68381-1.32748-1.91931-2.56502-3.41202-2.5237-2.24359,.0621-3.38562,3.07262-2.50089,5.13538s2.96378,3.30817,4.91583,4.41597c-4.64911,2.09151-10.41629,1.44022-14.48184-1.63548-4.06552-3.0757-6.26096-8.44832-5.51282-13.491,1.05423-7.10612,11.40649-5.63531,12.62604-12.71492,.88773-5.15372,4.00543-13.77715,3.15622-18.93732-.84921-5.16022-4.92761,1.08784-.63123-1.89372-4.72678,2.27867-14.83731-13.30983-19.78568-15.05585-4.9483-1.74602-9.14395-5.5267-11.39401-10.26715-5.24844,7.60822-9.86523,5.54211-11.7449,14.59186s-.14172,29.60976,7.59799,34.66228c-3.09744,2.11334-5.56662,5.13551-7.01993,8.59212-.82333,1.95819-1.35712,4.10081-2.72366,5.72716-2.60992,3.10617-7.42911,3.2951-11.27026,1.98909-4.76288-1.61942-8.83514-5.17625-11.08047-9.67805-2.24533-4.50182-2.63675-9.89452-1.06506-14.67339l-.00006-.00003Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0,626.13574c0,.66003,.53003,1.19,1.19006,1.19H523.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#3f3d56"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M340.03772,.99983H134.36885c-23.32296,0-42.22995,18.90699-42.22995,42.22995V583.66266c0,23.32294,18.90695,42.22986,42.22986,42.22986h205.66896c23.32297,0,42.22995-18.90698,42.22995-42.22992V43.22978c0-23.32296-18.90698-42.22995-42.22995-42.22995Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.03781,626.89209H134.36888c-23.83691,0-43.22998-19.39258-43.22998-43.22949V43.22998C91.1389,19.39307,110.53196,0,134.36888,0h205.66896c23.83691,0,43.22998,19.39307,43.22998,43.22998V583.6626c0,23.83691-19.39307,43.22949-43.22998,43.22949h-.00003ZM134.36888,2c-22.73438,0-41.22998,18.49561-41.22998,41.22998V583.6626c0,22.73438,18.49561,41.22949,41.22998,41.22949h205.66896c22.73438,0,41.22998-18.49512,41.22998-41.22949V43.22998c0-22.73438-18.49561-41.22998-41.22998-41.22998H134.36888Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.14368,94.56643c-1.80561,0-3.27392,1.46831-3.27392,3.27392v26.1914c0,1.80561,1.46831,3.27392,3.27392,3.27392s3.27392-1.46831,3.27392-3.27392v-26.1914c0-1.80561-1.46831-3.27392-3.27392-3.27392Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.93558,87.46124h-82.66788c-3.50635,0-6.35907-2.85273-6.35907-6.35907s2.85272-6.35907,6.35907-6.35907h82.66785c3.50635,0,6.35907,2.85273,6.35907,6.35907s-2.85272,6.35907-6.35907,6.35907h.00003Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3822,137.46854h-80.3571c-2.02586,0-3.67427-1.64841-3.67427-3.67429s1.64841-3.67351,3.67427-3.67351h80.3571c2.02588,0,3.67352,1.64764,3.67352,3.67351s-1.64764,3.67427-3.67352,3.67427v.00002Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.32235,
    cy: 92.07002,
    rx: 64.899,
    ry: 63.53157,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.34912,60.02429c-8.64008,15.73267-17.28021,31.46545-25.92029,47.19818-5.50665-9.72955-10.98322-19.47626-16.50342-29.19818-1.90643-3.3576-7.09204-.33765-5.18079,3.02832,6.39911,11.2699,12.73193,22.57727,19.13104,33.84717,1.09412,1.92694,4.09796,1.97168,5.18085,0,9.49115-17.28241,18.9823-34.56482,28.47345-51.84717,1.8598-3.38647-3.31964-6.41742-5.18084-3.02832Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.61763,
    y: 14.65784,
    width: 46.49806,
    height: 5.96129,
    rx: 0.31021,
    ry: 0.31021,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.3363,
    cy: 15.8501,
    r: 4.76904,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.45114,
    cy: 15.8501,
    r: 4.76904,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.56598,
    cy: 15.8501,
    r: 4.76904,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.86826,157.13577c0,.66003,.53003,1.19,1.19006,1.19h204.28998c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H135.05832c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M319.75781,250.66658h-122.59802c-2.02586,0-3.67427-1.64842-3.67427-3.67429s1.64841-3.67351,3.67427-3.67351h122.59802c2.02588,0,3.67352,1.64764,3.67352,3.67352s-1.64764,3.67427-3.67352,3.67427Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75781,303.66656h-122.59802c-2.02586,0-3.67427-1.64841-3.67427-3.67429s1.64841-3.67352,3.67427-3.67352h122.59802c2.02588,0,3.67352,1.64764,3.67352,3.67352s-1.64764,3.67426-3.67352,3.67426v.00003Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75781,356.66656h-122.59802c-2.02586,0-3.67427-1.64841-3.67427-3.67429s1.64841-3.67352,3.67427-3.67352h122.59802c2.02588,0,3.67352,1.64764,3.67352,3.67352s-1.64764,3.67426-3.67352,3.67426v.00003Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.97525,
    cy: 246.53845,
    r: 9,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.97516,261.53845v-2c7.44385,0,13.5-6.05615,13.5-13.5s-6.05615-13.5-13.5-13.5v-2c8.54688,0,15.5,6.95312,15.5,15.5s-6.95312,15.5-15.5,15.5Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.97525,
    cy: 299.53845,
    r: 9,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.97516,314.53845v-2c7.44385,0,13.5-6.05566,13.5-13.5,0-7.44385-6.05615-13.5-13.5-13.5v-2c8.54688,0,15.5,6.95312,15.5,15.5s-6.95312,15.5-15.5,15.5Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.97525,
    cy: 352.53845,
    r: 9,
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.97516,367.53845v-2c7.44385,0,13.5-6.05566,13.5-13.5s-6.05615-13.5-13.5-13.5v-2c8.54688,0,15.5,6.95312,15.5,15.5s-6.95312,15.5-15.5,15.5Z",
    fill: "#3f3d56"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M384.01218,203.75047c5.55215-1.40863,11.8468,4.52132,14.06128,13.24854,.93243,3.47409,1.01932,7.12088,.25339,10.63535l2.38571,9.92043,.17551-.00925,18.81824,44.34888c4.37546,10.31165,3.91315,22.14969-1.66766,31.862-3.31989,5.77765-7.67792,9.66177-12.79498,5.69681-8.49084-6.57913-14.03687-44.24918-16.56906-65.88826l-5.85495-21.9959c-2.35019-2.72464-4.01346-5.97256-4.85068-9.47191-2.2149-8.72385,.49106-16.938,6.04318-18.34671l.00003,.00003Z",
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.38873 228.05283 384.33502 243.01874 394.86188 309.31265 408.06461 326.38766 423.44391 321.0686 427.94067 289.72998 422.64886 259.42288 405.38873 228.05283",
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.a8b677f7e1d8ac6f05c05ce1a040e718.svg";
export { ForwardRef as ReactComponent };